import * as React from 'react';
export const postSvg = React.forwardRef(function postSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#EE3124',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M4.034 15.963c-.043.021-.046.06-.005.085l3.703 2.315 1.06-4.724-4.758 2.324Zm19.919-2.325H17.43l-1.06 4.725h6.522c.048 0 .055-.02.015-.045l-3.71-2.314 4.766-2.328c.043-.02.038-.038-.01-.038Z',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M23.663 10.546H8.307c-.857 0-1.457.51-1.599 1.14-.077.347.062.655.344.866L12.569 16l.004-.002.001.002 11.1-5.416c.043-.021.038-.038-.01-.038Z',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'm21.228 21.409-8.654-5.41-.001.003-.004-.002-7.066 3.448c-.377.21-.654.519-.731.866-.143.63.227 1.14 1.085 1.14h15.356c.05 0 .055-.02.015-.045Z',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M25.958 13.638h-.936a.461.461 0 0 0-.167.038l-4.693 2.288c-.044.021-.046.06-.005.084l3.64 2.269a.382.382 0 0 0 .163.045h.936c.048 0 .055-.02.015-.045l-3.716-2.315 4.772-2.327c.044-.021.04-.037-.009-.037Z',
      fill: '#F58220',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M27.96 13.638h-.936a.459.459 0 0 0-.167.038l-4.693 2.288c-.043.021-.045.06-.005.084l3.641 2.269c.04.024.114.045.162.045h.937c.048 0 .055-.02.014-.045l-3.716-2.315 4.773-2.327c.043-.021.04-.037-.01-.037Z',
      fill: '#FDB913',
    }),
  );
});
postSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var post = {
  category: 'brand',
  colorable: false,
  name: 'post',
  svg: postSvg,
};
